import React from 'react';
import { subscribeGallery } from '../lib/gallery';
import { currentDevice, observeDevice } from '../lib/layout';

// Neuheiten: eine reine Bilderliste wie die Highlights, verwaltet im
// Admin-Bereich. Solange keine Bilder hinterlegt sind, blendet home.js den
// Menuepunkt aus — diese Komponente ist dann gar nicht erreichbar.
class Neuheiten extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // null heisst: noch nichts geladen, siehe landing.js.
            items: null,
            columns: null,
            geraet: currentDevice()
        }
    }

    componentDidMount() {
        var that = this;
        this.disposeDevice = observeDevice(function (geraet) {
            that.setState({ geraet: geraet });
        });
        this.unsubscribe = subscribeGallery(function (gallery) {
            that.setState({
                items: gallery.neuheiten.items,
                columns: gallery.neuheiten.columns
            });
        });
    }

    componentWillUnmount() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
        if (this.disposeDevice) {
            this.disposeDevice();
        }
    }

    render() {
        if (!this.state.items) {
            return <div class='fullwidthcontainer' />;
        }
        var spalten = this.state.columns[this.state.geraet];
        // Die ersten beiden Reihen sofort, alles darunter beim Scrollen.
        var list = this.state.items.map(function (item, index) {
            return <img src={item.src} alt='Neuheit' class='smallimage' key={item.src}
                loading={index < 6 ? 'eager' : 'lazy'} decoding='async' />;
        });

        return (
            <div class='fullwidthcontainer' style={{ '--spalten': spalten }}>
                {list}
            </div>
        );
    }
}

export default (Neuheiten);
